<h1 mat-dialog-title class="p-2 text-center">Ajout de mesures</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <mat-form-field class="col">
            <mat-select placeholder="Type de mesure" [(ngModel)]="SelectedUsage" (selectionChange)="getZoneOrProcessAvailable()" [compareWith]="compareWith" [disabled]="LoadingTask.IsLoading > 0">
                @for (u of UsageList; track u; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{u}} </span>
                </mat-option>
                }
                <mat-option [value]="0">
                    <span> Mesure opérateur </span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-select placeholder="Zone / Processus" [(ngModel)]="SelectedParent" (selectionChange)="getMeasureAvailableForThatZoneProcess()"
                        [compareWith]="compareWith" [disabled]="LoadingTask.IsLoading > 0">
                @for (m of ZoneProcessList; track m) {
                <mat-option [value]="m">
                    @if (m.CustomerRef) {
                    <span class="text-truncate">{{m.ParentName}} </span>
                    }
                    @if (!m.CustomerRef) {
                    <span class="text-truncate">{{m.ParentName}} - {{m.ParentDescription}}</span>
                    }
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-selection-list (selectionChange)="SetSelection($event)" multiple>
            @for (m of MeasureList; track m) {
            <mat-list-option [value]="m" [selected]="m.IsSelected">
                @if (IsFDX) {
                <span> {{m.MeasureReferenceDesignation}} @if (m.ZoneUsage === EZoneUsage.Environmental) {
                    <span> - {{getFrequencyLabel(m.Frequency)}}</span>
                    }</span>
                }
                @if (!IsFDX) {
                <span>{{ m.MeasureReferenceName}} - {{m.MeasureReferenceDesignation}} </span>
                }
            </mat-list-option>
            }
        </mat-selection-list>
    </div>

    @if (IsDispatch) {
    <div class="row no-gutters justify-content-center my-3">
        <div class="col">
            <mat-form-field class="w-100">
                <input matInput placeholder="EDI Analysis Number" [(ngModel)]="EDIAnalysisNumber">
            </mat-form-field>
        </div>
    </div>
    }

    <div class="row my-3">
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="WithBattery">
            Batterie*
        </mat-slide-toggle>

        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="WithExpressDelay">
            Express*
        </mat-slide-toggle>

        @if (IsDispatch) {
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="HasFan">
            Ventilateur*
        </mat-slide-toggle>
        }

        @if (IsDispatch) {
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="IsAccredited">
            Accrédité
        </mat-slide-toggle>
        }
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd()">
            Ajouter
        </button>
    </div>
</div>